/** Costanti e helper UI condivisi · Rebranding 2026 */

export const SECTION_SELECTED_KEY = 'sectionSelected';

export const getSectionSelected = () => localStorage.getItem(SECTION_SELECTED_KEY);

export const isDocenteSectionSelected = () => getSectionSelected() === 'docente';

export const isMemberSectionSelected = () => getSectionSelected() === 'member';

export const shouldShowDocenteSectionChoice = user =>
  Boolean(user?.memberIsDocente && user?.docenteIframe && !getSectionSelected());

export const resolveYearItemDefaultOpen = (year, defaultOpen) =>
  defaultOpen !== undefined ? defaultOpen : year === new Date().getFullYear();
